import { render } from "./XmlElement.vue?vue&type=template&id=d071a178&scoped=true"
import script from "./XmlElement.vue?vue&type=script&lang=js"
export * from "./XmlElement.vue?vue&type=script&lang=js"

import "./XmlElement.vue?vue&type=style&index=0&id=d071a178&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d071a178"]])

export default __exports__